var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-output',{attrs:{"errors":_vm.errors}},[_c('a-range-picker',_vm._b({ref:"focusOnMount",class:[
      'datepicker',
      { 'datepicker--with-time': _vm.showTime, 'datepicker--full-wdth': _vm.fullWidth, readOnly: _vm.readOnly },
    ],attrs:{"format":_vm.format,"showTime":_vm.showTime,"disabled":_vm.disabled || _vm.readOnly,"locale":"ru-RU","placeholder":[_vm.placeholder, _vm.placeholder],"align":{
      offset: _vm.isInlineTable ? [-16, -6] : [0, 0],
    }},on:{"blur":function($event){return _vm.$emit('blur')},"ok":_vm.close,"change":_vm.change},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'a-range-picker',_vm.optionalPickerProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }